module.exports = __webpack_public_path__ + "static/exam-8a285a3eb835dda298178f2fbb3921a4.jpg";